import React, { FC, useMemo } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Outlet, useLocation } from "react-router-dom";
import useIsPortal from "../hooks/useIsPortal";

/**
 * Helper function to make tabs selectable by keyboard
 * @param index the tab index
 */
function a11yProps(index: number): { id: string; "aria-controls": string } {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

/**
 * The Tables route element. Includes Header and Drawer Elements, tables are placed inside using
 * react-routers Outlet component.
 */
const TablesPage: FC = () => {
  const location = useLocation();
  const { isPortal } = useIsPortal();

  const routes = useMemo(() => {
    return [
      "/content/tables/seclevels",
      "/content/tables/accounts",
      `/content/tables/webmap${isPortal ? "s" : ""}`,
    ];
  }, [isPortal]);

  return (
    <Box
      sx={{
        "& .grid-header": {
          // TODO: investigate why this is not working, maybe it's not auto loading the bold style
          fontWeight: "bold !important",
        },
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider", height: "50x" }}>
        <Tabs aria-label="Tabellen" value={routes.indexOf(location.pathname)}>
          <Tab
            label="Security Levels"
            href="/content/tables/seclevels"
            {...a11yProps(0)}
          />
          <Tab
            label="Nutzer:innen"
            href="/content/tables/accounts"
            {...a11yProps(1)}
          />
          <Tab
            label={`Webmap${isPortal ? "s" : ""}`}
            href={`/content/tables/webmap${isPortal ? "s" : ""}`}
            {...a11yProps(2)}
          />
        </Tabs>
      </Box>
      <Outlet />
    </Box>
  );
};

export default TablesPage;
